import { router } from '@inertiajs/react'

/**
 * Design v2 flag plumbing (client side).
 *
 * The server renders `<html data-design="v2">` for users with Flipper `:design_v2`
 * (app/views/inertia.html.erb), so the first paint is already correct. Inertia visits
 * swap page props without a full reload, so the attribute is re-synced from the shared
 * `design_v2` prop on every navigation (flag toggled mid-session, sign in/out).
 */
export const DESIGN_ATTR = 'data-design'
export const DESIGN_V2 = 'v2'

type PropsLike = { design_v2?: unknown } | null | undefined

export function isDesignV2(props: PropsLike): boolean {
  return props?.design_v2 === true
}

export function applyDesignV2(enabled: boolean, root: HTMLElement = document.documentElement): void {
  if (enabled) {
    if (root.getAttribute(DESIGN_ATTR) !== DESIGN_V2) root.setAttribute(DESIGN_ATTR, DESIGN_V2)
  } else if (root.hasAttribute(DESIGN_ATTR)) {
    root.removeAttribute(DESIGN_ATTR)
  }
}

/** Subscribe to Inertia navigations. Returns the unsubscribe function. */
export function syncDesignV2OnNavigate(): () => void {
  return router.on('navigate', (event) => {
    applyDesignV2(isDesignV2(event.detail.page.props as PropsLike))
  })
}
